import { NetworkCreateForm, NetworkStatus, NetworkUpdateForm } from 'chaika-frontend-types/frontend-cms';

import { store } from '@store';
import { priceListService } from '@price/service/priceList/priceListService';
import { NetworkApi } from '@organization/api/NetworkApi';

class NetworkService {
    public async load(): Promise<void> {
        const networkList = store.networkList;

        if (networkList.ids.length === 0) {
            const networks = await NetworkApi.getList();

            networkList.set(networks);
        }
    }

    public async create(params: NetworkCreateForm): Promise<void> {
        const networkList = store.networkList;

        await NetworkApi.create(params);

        networkList.add([{ ...params, status: NetworkStatus.Active }]);
    }

    public async update(id: string, updateParams: NetworkUpdateForm): Promise<void> {
        const networkList = store.networkList;

        const current = networkList.get(id);

        const promises: Promise<void>[] = [];

        if (updateParams && Object.keys(updateParams).length > 0) {
            promises.push(NetworkApi.update(id, updateParams));
        }

        await Promise.all(promises);

        networkList.update(id, { ...current, ...updateParams });
    }

    public async updateStatus(id: string, status: NetworkStatus): Promise<void> {
        const networkList = store.networkList;

        await NetworkApi.updateStatus(id, status);

        const current = networkList.get(id);

        networkList.update(id, { ...current, status });
    }

    public async loadNetworksPriceList(): Promise<void> {
        await Promise.all([this.load(), priceListService.loadCompositeServices()]);
    }
}

export const networkService = new NetworkService();
